import { IAchievement } from 'models/Achievement'
import { IPayload } from 'models/Global'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class AchievementsApi {
  constructor(private axios: AxiosService) {}

  getAchievement = async (id: number, params?: IAchievement) => {
    const response = await this.axios.get<IPayload<IAchievement>>(
      Endpoints.getAchievement(id),
      params,
    )
    return response
  }
}
